import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { push } from 'redux-first-history';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { login } from '../../store/auth';

export default function SignInForm() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const email = location.hash.replace('#confirmed=', '');
    if (email && location.hash.includes('#confirmed')) {
      toastr.success('Email confirmed', email);
      setEmail(email);
    }
  }, [location.hash]);

  const handleNavigate = (path) => {
    dispatch(push(path));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <>
      <Typography variant='h4'>Sign In</Typography>
      <List disablePadding>
        <form>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              id='username'
              label='Email'
              placeholder='Enter email'
              fullWidth
              required
              autoComplete='username'
              onChange={(e) => setEmail(e.target.value)}
              variant='standard'
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              id='password'
              label='Password'
              placeholder='Enter password'
              type='password'
              autoComplete='current-password'
              fullWidth
              required
              onChange={(e) => setPassword(e.target.value)}
              variant='standard'
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              fullWidth
              onClick={handleSubmit}>
              Submit
            </Button>
          </ListItem>
        </form>
      </List>
      <Link
        color='inherit'
        underline='hover'
        variant='body1'
        sx={{ cursor: 'pointer', mb: 1 }}
        onClick={() => handleNavigate('/auth/#forgot')}>
        Forgot your password?
      </Link>
      <br />
      <Typography display='inline'>Don't have an account? </Typography>
      <Link
        color='inherit'
        underline='hover'
        variant='body1'
        sx={{ cursor: 'pointer' }}
        onClick={() => handleNavigate('/auth/#signup')}>
        Sign Up
      </Link>
    </>
  );
}
